export const iconFontAwesomeEmojiFaceGrinHearts = (
	<i className="fa-solid fa-face-grin-hearts"></i>
);
